import Head from 'next/head';
import { useIntl } from 'react-intl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { useConfig } from '@packages/utilities';
import { useRouter } from 'next/router';
import { RatingPageSeoFragmentFragmentDoc } from '@packages/gql/generated/shopping/RatingPageSeoFragmentFragmentDoc';
import { ratingPageHeadMessages } from './messages';

/* TODO: replace frontend-logic with graphql-call to seo-resolver for title and canonical */

/* GraphQL */ `
  fragment RatingPageSeoFragment on Product {
    name
    seo(locale: $locale) {
      title
      description
      keywords
    }
  }
`;

interface RatingPageHeadProps {
  data: FragmentType<typeof RatingPageSeoFragmentFragmentDoc>;
}

/**
 * RatingPageHead component description displayed in storybook
 * */
export const RatingPageHead = ({ data }: RatingPageHeadProps) => {
  const { formatMessage } = useIntl();
  const { asPath } = useRouter();
  const { host, company } = useConfig();
  const { name, seo } = getFragmentData(RatingPageSeoFragmentFragmentDoc, data);

  return (
    <Head>
      <title>{`${formatMessage(ratingPageHeadMessages.title)} | ${
        seo?.title && seo.title.length > 0
          ? seo.title.replace('{ProductName}', name)
          : `${name} | ${company.seoTitleName}`
      }`}</title>
      <meta name="robots" content="noodp,noindex,follow" />
      <link href={`https://www.${host.domain}${asPath}`} rel="canonical" />
      {seo?.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo?.description && (
        <meta
          name="description"
          content={seo.description.replace('{ProductName}', name).replace(/"/g, '&quot;')}
        />
      )}
    </Head>
  );
};
